var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bottom"},[_vm._v(" Copyright © 2021 PLOOT - DDDD, All rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }